
 // Time-boxed offers. "Now" can be overridden for QA with
// ?preview_date=2026-11-12T00:00:00+05:30
// Preview dates are enabled in development or when
// REACT_APP_ALLOW_PREVIEW_DATE=true is configured.

const allowPreview =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_ALLOW_PREVIEW_DATE === "true";

export function now() {
  if (allowPreview) {
    const params = new URLSearchParams(window.location.search);
    const previewDate = params.get("preview_date");

    if (previewDate) {
      const date = new Date(previewDate);

      if (!Number.isNaN(date.getTime())) {
        return date;
      }
    }
  }

  return new Date();
}

export function isExpired(end, at = now()) {
  return at.getTime() > end.getTime();
}

/** Whole days left, counting today; 0 once expired. */
export function daysLeft(end, at = now()) {
  const ms = end.getTime() - at.getTime();

  return ms <= 0 ? 0 : Math.ceil(ms / 86_400_000);
}
